import * as o from "react";
import e from "../lib/IconBase.es.js";
import t from "../defs/Scissors.es.js";
const s = o.forwardRef((r, c) => /* @__PURE__ */ o.createElement(e, { ref: c, ...r, weights: t }));
s.displayName = "ScissorsIcon";
const m = s;
export {
  m as Scissors,
  s as ScissorsIcon
};
